import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import './Home.css';
import CourseBanner from '../components/CourseBanner';

const Home = () => {
    const { ref, inView } = useInView({
        threshold: 0.3,
        triggerOnce: true
    });

    return (
        <div className="home-page">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content" data-aos="fade-up">
                    <h1 className="reveal">Learn VLSI Physical Design <span style={{ color: 'var(--accent-gold)' }}>from Experts</span></h1>
                    <p className="reveal">Industry-standard training for aspiring semiconductor professionals. PNR, STA, and Synthesis.</p>
                    <div className="hero-btns reveal">
                        <Link to="/courses/physical-design" className="btn btn-gold">Explore Courses</Link>
                        <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
                    </div>
                </div>
            </section>

            {/* About Institute */}
            <section className="about-section" ref={ref}>
                <div className="section-header" data-aos="fade-up">
                    <span className="subtitle">About THEIC</span>
                    <h2>Excellence in VLSI Training</h2>
                </div>
                <div className="about-grid">
                    <div className="about-text" data-aos="fade-right">
                        <p>THEIC is a premier training institute dedicated to bridging the gap between academia and the semiconductor industry. Our curriculum is designed by veterans with decades of experience in top-tier silicon companies.</p>
                        <p>We focus on hands-on lab sessions and real-world project scenarios to ensure our students are industry-ready from day one.</p>
                    </div>
                    <div className="about-stats" data-aos="fade-left">
                        <div className="stat-card glass">
                            <h3>
                                {inView ? <CountUp end={10} duration={2.5} /> : '0'}+
                            </h3>
                            <p>Years Experience</p>
                        </div>
                        <div className="stat-card glass">
                            <h3>
                                {inView ? <CountUp end={12} duration={2.5} /> : '0'}+
                            </h3>
                            <p>Students Trained</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Course Overview */}
            <section className="course-highlight" data-aos="fade-up">
                <div className="section-header">
                    <span className="subtitle">OUR PROGRAMS</span>
                    <h2>Our Courses</h2>
                </div>
                <div className="course-grid">
                    <div className="course-card glass" data-aos="zoom-in" data-aos-delay="100">
                        <h3>Physical Design</h3>
                        <p>Comprehensive training on Synthesis, PNR, and Timing Analysis.</p>
                        <Link to="/courses/physical-design" className="text-link">View Details &rarr;</Link>
                    </div>
                    <div className="course-card glass" data-aos="zoom-in" data-aos-delay="200">
                        <h3>DFT</h3>
                        <p>Design for Testability: Master Scan, ATPG, and BIST methodologies.</p>
                        <Link to="/courses/dft" className="text-link">View Details &rarr;</Link>
                    </div>
                </div>
            </section>

            {/* Benefits */}
            <section className="benefits" data-aos="fade-up">
                <div className="section-header">
                    <span className="subtitle">Why Choose Us</span>
                    <h2>The THEIC Advantage</h2>
                </div>
                <div className="benefits-grid">
                    <div className="benefit-item" data-aos="fade-up" data-aos-delay="100">
                        <div className="icon">01</div>
                        <h4>Industry Experts</h4>
                        <p>Learn directly from professionals currently working in the VLSI industry.</p>
                    </div>
                    <div className="benefit-item" data-aos="fade-up" data-aos-delay="200">
                        <div className="icon">02</div>
                        <h4>Hands-on Training</h4>
                        <p>Access to industry-standard tools and real project environments.</p>
                    </div>
                    <div className="benefit-item" data-aos="fade-up" data-aos-delay="300">
                        <div className="icon">03</div>
                        <h4>Placement Support</h4>
                        <p>Mock interviews, resume building, and direct placement assistance.</p>
                    </div>
                </div>
            </section>

            {/* Course Banner */}
            <CourseBanner title="Featured Program" />

            {/* Contact CTA */}
            <section className="cta-section" data-aos="zoom-in">
                <div className="cta-card glass">
                    <h2>Ready to start your VLSI Career?</h2>
                    <p>Join our next batch and transform your future in semiconductors.</p>
                    <Link to="/contact" className="btn btn-gold">Contact Us Now</Link>
                </div>
            </section>
        </div>
    );
};

export default Home;
